import { render, staticRenderFns } from "./VisitReq.vue?vue&type=template&id=89c50b06&"
import script from "./VisitReq.vue?vue&type=script&lang=js&"
export * from "./VisitReq.vue?vue&type=script&lang=js&"
import style0 from "./VisitReq.vue?vue&type=style&index=0&id=89c50b06&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports